import { Box } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/StyledComponents";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Title } from "@similarweb/ui-components";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { colorsPalettes } from "@similarweb/styles";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import styled from "styled-components";

export const ChartContainer = styled.div`
    display: flex;
    background-color: ${colorsPalettes.carbon["0"]};
    width: 100%;
    justify-content: center;
    border-radius: 4px;
    height: 450px;
    .highcharts-label-box.highcharts-tooltip-box:not(.highcharts-shadow) {
        fill: ${colorsPalettes.carbon["0"]};
        fill-opacity: 1;
        stroke-width: 0;
    }
`;

export const BuyerJourneyBoxContainer = styled.div`
    padding: 40px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    align-items: center;
`;

export const BoxContainer: any = styled(Box)<{ isEmptyState: boolean }>`
    ${({ isEmptyState }) =>
        isEmptyState
            ? `
                cursor: unset;
                &:hover {
                    box-shadow: none;
                }
            `
            : ""};
    width: 100%;
    max-width: 1368px;
    height: auto;
    border-radius: 6px 6px 0px 0px;
    flex-direction: column;
    background-color: ${colorsPalettes.carbon["0"]};
    padding: 0px;
`;

export const TitleContainer = styled(FlexRow)`
    box-sizing: border-box;
    padding: 24px 24px 12px 24px;
    justify-content: space-between;
    flex: 1 0;
    width: 100%;
`;

export const StyledHeaderTitle = styled(Title)`
    font-size: 20px;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const ContentContainer = styled.div`
    width: 100%;
`;

const GroupContainer = styled.div`
    padding: 24px 24px 12px 24px;
`;

const DropdownLabel = styled.span`
    padding-left: 24px;
    padding-right: 12px;
    font-size: 14px;
    font-weight: 600;
`;

export const NotificationBannerContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 0;
    width: 100%;
    .user-flow-pager-notification-banner {
        max-width: 1320px;
        width: calc(100% - 16px);
        margin: 0 16px;
    }
`;

export const StyledDefaultCellHeader = styled(DefaultCellHeader)`
    width: 100%;
    position: absolute;
    line-height: 32px;
    background-color: ${colorsPalettes.midnight[500]};
    padding-left: 12px;
    margin-left: -12px;
    margin-right: -12px;
    color: ${colorsPalettes.carbon[0]};
    .headerCell-sortDirection {
        top: 4px;
    }
`;
